import React from 'react';
import Hero from '../sections/Hero';
import Features from '../sections/Features';
import Subscription from '../sections/Subscription';
import HowItWorks from '../sections/HowItWorks';
import DownloadSection from '../sections/DownloadSection';
import RevenueModel from '../sections/RevenueModel';
import CTA from '../sections/CTA';

export default function Home() {
  return (
    <main>
      <Hero />
      <Features />
      <Subscription />
      <HowItWorks />
      <DownloadSection />
      <RevenueModel />
      <CTA />
    </main>
  );
}

